module.exports = __webpack_public_path__ + "static/media/arc_desk_portfolio_laptop.123bccb3.png";